import React, { useRef } from "react";
import { getImageUrl } from "@/config/images";
import { SPLASH_VIEWBOX, SPLASH_MAIN } from "@/components/splash/splashPaths";

/*
 * Loader for phones/tablets: the spray-painted smiley with its spray texture baked into images
 * (public/images/intro/smiley-*.webp), so nothing is filtered live.
 * Once its images are in, it is sprayed on part by part, drips and trembles; on .intro-burst
 * it swells and pops into a splash. Timings live in App.css ("SMILEY, LITE").
 */

const LAYERS = ["specks", "ring", "eye-1", "eye-2", "smile"];

// Paint running down from the ring and the smile: x, start y, width, length, delay (ms)
const DRIPS = [
  { x: 112, y: 286, w: 6, len: 40, delay: 0 },
  { x: 150, y: 324, w: 5, len: 26, delay: 180 },
  { x: 199, y: 346, w: 7, len: 48, delay: 90 },
  { x: 232, y: 290, w: 5, len: 30, delay: 260 },
  { x: 262, y: 333, w: 5, len: 22, delay: 140 },
  { x: 300, y: 300, w: 6, len: 36, delay: 220 },
];

const SmileyLoaderLite = ({ onReady }) => {
  const loaded = useRef(0);
  const rootRef = useRef(null);

  // start spraying only when every layer is there (or failed), so it never plays on empty
  const layerDone = () => {
    loaded.current += 1;
    if (loaded.current === LAYERS.length) {
      rootRef.current?.classList.add("sm-ready");
      onReady?.();
    }
  };

  return (
    <div ref={rootRef} className="sm sm-lite absolute inset-0 flex items-center justify-center overflow-hidden" aria-hidden="true">
      <div className="absolute inset-0 spray-texture opacity-60" />
      <div className="sm-grow">
        <div className="sm-shake">
          <div className="sm-shake-2">
            <div className="sm-face">
              {LAYERS.map((name) => (
                <img
                  key={name}
                  className={`sm-layer sm-${name}`}
                  src={getImageUrl(`intro/smiley-${name}.webp`)}
                  alt=""
                  onLoad={layerDone}
                  onError={layerDone}
                />
              ))}
              <svg className="sm-layer" viewBox="0 0 400 400" fill="#ECCE21">
                {DRIPS.map((drip, i) => (
                  <g key={i} style={{ "--d": `${drip.delay}ms`, "--len": `${drip.len}px` }}>
                    <rect className="sm-drip-stem" x={drip.x - drip.w / 2} y={drip.y} width={drip.w} height={drip.len} />
                    <circle className="sm-drip-bulb" cx={drip.x} cy={drip.y} r={drip.w * 0.7} />
                  </g>
                ))}
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* when it pops: a splash bursts out of the face */}
      <svg className="sm-burst" viewBox={SPLASH_VIEWBOX}>
        <path d={SPLASH_MAIN} fill="#ECCE21" />
      </svg>
    </div>
  );
};

export default SmileyLoaderLite;
